/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */

import { Changeset } from '../../Changeset';
import type { FeatureWrapper, DataPropertiesMap } from '../../../geo/features/FeatureWrapper';

export class SetFeaturePropertiesChangeset extends Changeset {
  constructor(
    private feature: FeatureWrapper,
    public readonly before: DataPropertiesMap,
    public readonly after: DataPropertiesMap,
  ) {
    super();
  }

  public async execute(): Promise<void> {
    const properties: DataPropertiesMap = { ...this.after };
    this.feature.setDataProperties(properties);
  }

  public async undo(): Promise<void> {
    const properties: DataPropertiesMap = { ...this.before };
    this.feature.setDataProperties(properties);
  }
}
